const TECHNICAL_UUID_SEGMENT = /^(?:PV[-_: ]?)?[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const normalizeIdentity = (value: unknown) => String(value ?? '').trim().toLocaleLowerCase('pl');

const looksLikeDimensionMetadata = (segment: string) => {
  const axisCount = segment.match(/(?:gr|szer|wys|dł)\.\s*\d/gi)?.length || 0;
  return axisCount >= 1 && /\bmm\b/i.test(segment);
};

/**
 * Older catalog rows may have been saved as
 * "name - product code - dimensions - EAN". Keep the business name while
 * dropping only delimiter-separated segments that exactly match known
 * technical values (or an unmistakable UUID/dimension metadata segment).
 * This module intentionally has no i18n/catalog dependencies so low-level DTO
 * and form mappers can reuse it without initializing the UI runtime.
 */
export const sanitizeProductDisplayName = (
  value: unknown,
  technicalValues: readonly unknown[] = [],
) => {
  const raw = String(value ?? '').trim();
  if (!raw) return '';

  const technical = new Set(technicalValues.map(normalizeIdentity).filter(Boolean));
  return raw
    .split(/\s+-\s+/)
    .map((segment) => segment.trim())
    .filter((segment) => {
      const normalized = normalizeIdentity(segment);
      return normalized
        && !technical.has(normalized)
        && !TECHNICAL_UUID_SEGMENT.test(segment)
        && !looksLikeDimensionMetadata(segment);
    })
    .join(' - ')
    .trim();
};
